export function createMockMidiTransport(options = {}) {
    const inputs = options.inputs ?? [
        { id: 'mock-in-1', name: 'Mock MIDI Input 1', state: 'connected' },
    ];
    const outputs = options.outputs ?? [
        { id: 'mock-out-1', name: 'Mock MIDI Output 1', state: 'connected' },
    ];
    const sysExEnabled = options.sysExEnabled ?? true;
    const browserInfo = {
        supported: true,
        browser: 'Mock MIDI',
        notes: 'Deterministic transport for tests and screenshot capture.',
        ...options.browserInfo,
    };
    let stateHandler = null;
    const listeners = new Set();
    const sentMessages = [];
    const adapter = {
        send: (message) => {
            sentMessages.push([...message]);
        },
        onSysEx: (callback) => {
            listeners.add(callback);
        },
        removeSysExListener: (callback) => {
            listeners.delete(callback);
        },
    };
    const getPorts = () => ({
        inputs,
        outputs,
        sysExEnabled,
    });
    return {
        transport: {
            kind: 'mock-midi',
            isSupported: () => true,
            getBrowserInfo: () => browserInfo,
            initialize: async () => getPorts(),
            refresh: async () => getPorts(),
            onStateChange: (handler) => {
                stateHandler = handler;
            },
            connect: async (inputId, outputId) => {
                const inputInfo = inputs.find((port) => port.id === inputId);
                const outputInfo = outputs.find((port) => port.id === outputId);
                if (!inputInfo)
                    throw new Error(`Input port not found: ${inputId}`);
                if (!outputInfo)
                    throw new Error(`Output port not found: ${outputId}`);
                return {
                    adapter,
                    inputInfo,
                    outputInfo,
                    disconnect: async () => { },
                };
            },
        },
        controls: {
            emitSysEx: (message) => {
                listeners.forEach((listener) => listener([...message]));
            },
            getSentMessages: () => [...sentMessages],
            triggerStateChange: () => {
                stateHandler?.();
            },
        },
    };
}
//# sourceMappingURL=mockMidiTransport.js.map